import moment from "moment";

export default {
  filters: {
    formatDate(date, format = 'D MMM YYYY') {
      return moment(date).format(format);
    },
  },
}